import React, { useContext } from "react";
import { FaEdit, FaEye, FaTrash } from "react-icons/fa";
import { GiTooth } from "react-icons/gi";
import ReactPaginate from "react-paginate";
import { SettingGeneralContext, SettingGeneralProvider } from "../../../context/settingGeneralContext";

export default function TableAppointmentHistory({
  getData,
  rows,
  page,
  pages,
  changePage,
  msg,
  viewModalUpdate,
  modalDetailPatient,
  modalOdontogramPatient,
  deleteById
}) {
  return (
    <SettingGeneralProvider>
      <TableAppointmentHistoryContent
        getData={getData}
        rows={rows}
        page={page}
        pages={pages}
        changePage={changePage}
        modalDetailPatient={modalDetailPatient}
        modalOdontogramPatient={modalOdontogramPatient}
        msg={msg}
        viewModalUpdate={viewModalUpdate}
        deleteById={deleteById}
      />
    </SettingGeneralProvider>
  );
}

function TableAppointmentHistoryContent({
  getData,
  rows,
  page,
  pages,
  changePage,
  msg,
  modalDetailPatient,
  modalOdontogramPatient,
  viewModalUpdate,
  deleteById
}) {
  const context = useContext(SettingGeneralContext);
  const state = context?.state || {};

  const appSidebarColor1 = state?.showTheme?.app_sidebar_color_1;
  const appSidebarColor2 = state?.showTheme?.app_sidebar_color_2;
  const appSidebarColor3 = state?.showTheme?.app_sidebar_color_3;
  const appSidebarColor4 = state?.showTheme?.app_sidebar_color_4;
  const appSidebarColor5 = state?.showTheme?.app_sidebar_color_5;

  const getRowNumber = (index) => (page - 1) * 10 + index + 1;

  // Styles tetap sama
  const styles = {
    tableContainer: {
      display: "block",
      height: "100%",
      overflowY: "auto",
      overflowX: "auto",
    },
    tableHeader: {
      backgroundColor: appSidebarColor1 || "#E9EFFF",
      whiteSpace: "nowrap",
    },
    tableHeaderCell: {
      fontFamily: "revert",
      fontSize: "12px",
      textAlign: "center",
      color: "#525252",
      border: "none",
    },
    tableRow: {
      fontFamily: "sans-serif",
      fontSize: "11px",
      textAlign: "center",
    },
    paginationLink: {
      backgroundColor: "red",
      color: "white",
      borderRadius: "5px",
      padding: "3px 6px",
      fontSize: "10px",
      width: "25px",
      height: "25px",
      margin: "2px",
      textAlign: "center",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
  };


  return (
    <>
      <div style={styles.tableContainer}>
        <table className="table is-bordered">
          <thead>
            <tr style={styles.tableHeader}>
              <th style={styles.tableHeaderCell}>No</th>
              <th style={styles.tableHeaderCell}>Patient</th>
              <th style={styles.tableHeaderCell}>Anamnesa</th>
              <th style={styles.tableHeaderCell}>Tanggal</th>
              <th style={styles.tableHeaderCell}>Total</th>
              <th style={styles.tableHeaderCell}></th>
            </tr>
          </thead>
          <tbody>
            {getData?.map((user, index) => {
              return (
                <>
                  <tr key={index} style={styles.tableRow}>
                    <td>{getRowNumber(index)}</td>
                    <td className="text-primary" onClick={() => modalDetailPatient(user?.patient_data?.id, user?.patient_data?.first_name, user?.patient_data?.last_name, user?.patient_data?.gender, user?.patient_data?.code, user?.patient_data?.date_birth, user?.patient_data?.age, user?.patient_data?.residence_address, user?.patient_data?.residence_address, user?.patient_data?.phone_number, user?.patient_data?.nic_number, user?.patient_data?.occupation, user?.patient_data?.medical_record_code, user?.patient_data?.email)} style={{ cursor: "pointer" }}>{user?.patient_data?.first_name} {user?.patient_data?.last_name}</td>
                    <td>{user?.anamnesa}</td>
                    <td>
                      {user?.date_plan
                        ? new Date(user.date_plan).toLocaleDateString("id-ID", {
                          day: "2-digit",
                          month: "long",
                          year: "numeric",
                        })
                        : "-"}
                    </td>
                    <td>
                      {user?.estimate_price_total
                        ? new Intl.NumberFormat("id-ID", {
                          style: "currency",
                          currency: "IDR",
                          minimumFractionDigits: 0,
                        }).format(user.estimate_price_total)
                        : "-"}
                    </td>
                    <td>
                      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "5px" }}>
                        <button className="btn btn-info"
                          onClick={() => modalOdontogramPatient(user?.id, user?.details[0]?.tooth_number, user?.patient_data?.first_name, user?.patient_data?.last_name, user?.details[0]?.description, user?.details[0]?.treatment_data?.name, user?.anamnesa, user?.id_appointment)}
                          style={{
                            fontSize: "12px",
                            color: "white",
                            padding: "5px 5px",
                            borderRadius: "3px",
                            cursor: "pointer",
                            border: "none",
                            display: "flex"
                          }}
                        >
                          <FaEye />
                        </button>
                        {/* <button
                          onClick={() => viewModalUpdate(user?.id, user?.name)}
                          style={{
                            fontSize: "12px",
                            color: "white",
                            backgroundColor: "#ff9933",
                            padding: "5px 5px",
                            borderRadius: "3px",
                            cursor: "pointer",
                            border: "none",
                            display: "flex"
                          }}
                        >
                          <FaEdit />
                        </button>
                        <button
                          onClick={() => deleteById(user?.id)}
                          style={{
                            fontSize: "12px",
                            color: "white",
                            backgroundColor: "#B60000",
                            padding: "5px 5px",
                            borderRadius: "3px",
                            cursor: "pointer",
                            border: "none",
                            display: "flex"
                          }}
                        >
                          <FaTrash />
                        </button> */}
                      </div>
                    </td>
                  </tr>
                </>
              )
            })}
          </tbody>
        </table>

        <div style={{ display: "flex", padding: "10px" }}>
          <div>
            <div style={{ fontSize: "12px" }}>Total Rows: {rows}</div>
            <div style={{ fontSize: "12px" }}>Page: {rows ? page : 0} of {pages}</div>
            <p className="has-text-centered has-text-danger">{msg}</p>
          </div>
          <div style={{ flex: "50%", display: "flex", justifyContent: "end" }}>
            <nav
              style={{ fontSize: "12px" }}
              className="pagination is-centered"
              key={rows}
              role="navigation"
              aria-label="pagination"
            >
              <ReactPaginate
                previousLabel={"<"}
                nextLabel={">"}
                pageCount={Math.min(10, pages)}
                onPageChange={changePage}
                containerClassName={"pagination-list"}
                pageLinkClassName={"pagination-link"}
                previousLinkClassName={"pagination-previous"}
                nextLinkClassName={"pagination-next"}
                activeLinkClassName={"pagination-link is-current"}
                disabledLinkClassName={"pagination-link is-disabled"}
              />
            </nav>
          </div>
        </div>
      </div>
    </>
  );
}
